<template>
  <div :style="backgroundStyleWithImage" v-if="imageSource"></div>
</template>

<script>
export default {
  name: "dynamicImageBackground",

  props: ["fileId", "backgroundStyle"],

  data() {
    return {
      imageSource: null,
    };
  },

  computed: {
    backgroundStyleWithImage() {
      return (
        this.backgroundStyle +
        ";background-image: url('" +
        this.imageSource +
        "')"
      );
    },
  },

  async mounted() {
    this.imageSource = encodeURI(this.baseUrl + "/file/" + this.fileId);
  },
  watch: {
    fileId: async function (value) {
      if (value) {
        this.imageSource = encodeURI(this.baseUrl + "/file/" + this.fileId);
      }
    },
  },


};
</script>

<style scoped>
div {
  height: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
</style>
